import type { WalletTransactionKind } from "@utopia-well-done-ltd/contracts";

/** What a ledger movement means in operator-facing language. */
export const WALLET_KIND_LABELS: Record<WalletTransactionKind, string> = {
  bet_partial_settle: "Bet partially settled",
  bet_release: "Bet returned",
  bet_reserve: "Bet placed",
  bet_settle: "Bet settled",
  bonus_convert: "Bonus converted",
  bonus_grant: "Bonus",
  deposit: "Deposit",
  play_money_top_up: "Play-money top-up",
  poker_buy_in: "Poker buy-in",
  poker_cash_out: "Poker cash-out",
  poker_hand_settle: "Poker hand settled",
  poker_hand_void: "Poker hand voided",
  poker_top_up: "Poker top-up",
  provider_settle: "Provider settlement",
  reversal: "Correction",
  withdrawal: "Withdrawal",
};
